import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { StoreTemplateStatus, TemplateGroup, ViewMode } from '@pt/pt-models';
import { GetChapterResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';
import { Chapter } from 'it/primatoo/openapi/api/org/schemas/common/docs/_listtemplatechapterresponse/Chapter';
import { ChapterStatus } from 'it/primatoo/openapi/api/org/schemas/common/docs/ChapterStatus';
import { AvailableOperations } from 'it/primatoo/openapi/api/org/schemas/common/AvailableOperations';
import { CommonDocumentEditorDetails } from '@primatoo-ms-organization';
import { WidgetType } from 'it/primatoo/openapi/api/org/schemas/common/docs/WidgetType';

@Component({
  selector: 'pt-template-editor-groups',
  template: `
    <div class='template-editor-groups'>
      <div class="d-flex justify-content-between">

        <pt-editor-chapter-status
          class="d-flex mb-2"
          [lockAcquired]="lockAcquired"
          [isDraft]="isDraft"
          [editorReady]="editorReady"
          [documentEditorDetails]="documentEditorDetails"
          [activeChapter]="activeChapter"
          [getChapterResponse]="getChapterResponse"
          (changeChapterStatus)="changeChapterStatus.emit($event)">
        </pt-editor-chapter-status>

        <pt-template-editor-view-selector
          [selectedViewMode]='selectedViewMode'
          [disabledListMode]='false'
          [disabledTabMode]='false'
          [disabledTabWithoutMode]='false'
          (changeViewMode)='changeViewMode.emit($event)'>
        </pt-template-editor-view-selector>

      </div>

      <pt-template-editor-group
        [viewMode]="selectedViewMode"
        [activeSmallView]='false'
        [lockAcquired]='lockAcquired'
        [selectedGroup]='selectedGroup'
        [groups]='visibleGroups'
        [activedEditWidgetId]='activedEditWidgetId'
        [status]='status'
        (changeTab)='onChangeGroup($event)'
      ></pt-template-editor-group>
    </div>
  `,
  styles: [`
    .template-editor-groups {
      margin-bottom: 10px;
    }
  `]
})
export class TemplateEditorGroupsComponent implements OnInit, OnChanges {
  @Input() editorReady: boolean;
  @Input() isDraft: boolean;
  @Input() documentEditorDetails: CommonDocumentEditorDetails;

  @Input() getChapterResponse: GetChapterResponse;
  @Input() documentPermission: AvailableOperations;
  @Input() activeChapter: Chapter;
  @Input() status: StoreTemplateStatus;
  @Input() lockAcquired: boolean;
  @Input() selectedGroup: TemplateGroup;
  @Input() viewMode = ViewMode.LIST;
  @Input() activedEditWidgetId: number;

  @Output() changeGroup = new EventEmitter<TemplateGroup>();
  @Output() changeViewMode = new EventEmitter<ViewMode>();
  @Output() changeChapterStatus = new EventEmitter<ChapterStatus>();

  public selectedViewMode = ViewMode.LIST;
  public WidgetType = WidgetType;
  public visibleGroups: TemplateGroup[] = [];
  public active = 0;

  ngOnInit(): void {
    this.loadingTabs();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedTemplateGroup) {
      this.onChangeGroup(changes.selectedTemplateGroup.currentValue);
    }
    if (changes.viewMode) {
      this.selectedViewMode = ViewMode.LOADING;
      this.loadingTabs();
      setTimeout(() => {
        this.selectedViewMode = changes.viewMode.currentValue;
      });
    }
  }

  onChangeGroup(group: TemplateGroup) {
    if (group) {
      this.getChapterResponse.payload.groups.forEach((g, index) => {
        if (g.id === group.id) {
          this.active = index;
          this.changeGroup.emit(group);
        }
      });
    }
  }

  private loadingTabs() {
    this.visibleGroups = [];
    if (this.getChapterResponse?.payload?.groups) {
      this.visibleGroups = this.getChapterResponse?.payload?.groups;
    }
  }

}
